import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { PureLink } from '../../basics';
import { CheckIcon } from '../../components';
import styles from './Step.module.scss';
const Step = ({ activeIndex, position, step }) => {
    const isActive = position === activeIndex;
    const completed = position < activeIndex;
    const stepIndex = position + 1;
    const stepClassNames = classNames('d-flex', 'flex-column', 'align-items-center', styles.circleContainer, {
        [styles.active]: isActive,
        [styles.completed]: completed,
    });
    const element = (_jsxs("div", { className: classNames('d-flex align-items-center flex-column', styles.stepWrapper), children: [_jsx("span", { className: classNames(styles.circle, 'd-inline-flex', 'justify-content-center', 'align-items-center', 'rounded-circle'), "aria-hidden": "true", children: completed ? _jsx(CheckIcon, {}) : stepIndex }), _jsx("span", { className: classNames(styles.text, 'mt-1x'), children: step.title })] }));
    if (step.url && completed) {
        return (_jsx(PureLink, { "data-testid": "step", href: step.url, onClick: (event) => {
                event.preventDefault();
                if (step.onClick) {
                    step.onClick(step, stepIndex);
                }
            }, className: stepClassNames, internal: true, "aria-label": step.a11yLabel, children: element }));
    }
    return (_jsx("span", { "data-testid": "step", className: stepClassNames, children: element }));
};
export { Step };
